import { create } from 'zustand'

interface ModalReassignAdviserV2State {
  modalReassignAdviserV2: {
    isOpen: boolean
    propertiesIds: string[]
    onSuccess?: () => void
    type: 'assign' | 'reassign'
    brokersData?: {
      fullName?: string
      photo?: string
    }[]
    mode?: 'modal' | 'in-modal'
  }
  setModalReassignAdviserV2: (modalReassignAdviserIsOpen: {
    isOpen: boolean
    propertiesIds: string[]
    onSuccess?: () => void
    type: 'assign' | 'reassign'
    brokersData?: {
      fullName?: string
      photo?: string
    }[]
    mode?: ModalReassignAdviserV2State['modalReassignAdviserV2']['mode']
  }) => void
  reset: () => void
}

export const useModalReassignAdviserV2Store =
  create<ModalReassignAdviserV2State>()((set) => ({
    modalReassignAdviserV2: {
      isOpen: false,
      propertiesIds: [],
      type: 'assign',
      brokersData: undefined,
      mode: 'modal'
    },
    setModalReassignAdviserV2: (modalReassignAdviserIsOpen) =>
      set({ modalReassignAdviserV2: modalReassignAdviserIsOpen }),
    reset: () =>
      set({
        modalReassignAdviserV2: {
          isOpen: false,
          propertiesIds: [],
          type: 'assign',
          brokersData: undefined,
          mode: 'modal'
        }
      })
  }))
